import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text, Paragraph } from "@zillow/constellation-10";
import { useFormContext } from "react-hook-form";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { useLastValidAmortizationValues } from "./AmortizationCalculator.utils.esm.js";
const AmortizationPaymentSummary = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidAmortizationValues(form);
  const baseCss = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "tighter",
    marginBottom: "tighter",
    width: "80%"
  };
  return /* @__PURE__ */ jsxs(Box, { css: {
    flex: 1,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    marginTop: "default"
  }, "aria-live": "polite", "aria-atomic": "true", children: [
    /* @__PURE__ */ jsx(Text, { asChild: true, textStyle: "heading-sm", "font-weight": "normal", children: /* @__PURE__ */ jsx("h2", { children: "Estimated monthly payment" }) }),
    /* @__PURE__ */ jsx(Text, { css: {
      marginBottom: "default"
    }, textStyle: "heading-lg", children: getWholeDollars(lastValidValues.calculations.monthlyPayment) }),
    /* @__PURE__ */ jsxs(Box, { css: {
      ...baseCss,
      borderBottom: "1px solid {colors.border.muted}"
    }, children: [
      /* @__PURE__ */ jsx(Paragraph, { children: "Total principal" }),
      /* @__PURE__ */ jsx(Text, { css: {
        color: "text.accent.green.hero"
      }, textStyle: "heading-sm", children: getWholeDollars(lastValidValues.calculations.totalPrincipal) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      ...baseCss,
      borderBottom: "1px solid {colors.border.muted}"
    }, children: [
      /* @__PURE__ */ jsx(Paragraph, { children: "Total interest" }),
      /* @__PURE__ */ jsx(Text, { css: {
        color: "text.accent.aqua.hero"
      }, textStyle: "heading-sm", children: getWholeDollars(lastValidValues.calculations.totalInterest) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: baseCss, children: [
      /* @__PURE__ */ jsx(Paragraph, { children: "Principal & interest" }),
      /* @__PURE__ */ jsx(Text, { css: {
        color: "text.accent.purple.hero"
      }, textStyle: "heading-sm", children: getWholeDollars(lastValidValues.calculations.totalPayment) })
    ] })
  ] });
};
export {
  AmortizationPaymentSummary as default
};
